import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { type IntegrationHubspotSettingsTicketOwnerStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationHubspotSettings/store/IntegrationHubspotSettingsTicketOwnerStore'
import styles from './styles.module.scss'

export const IntegrationHubspotSettingsTicketOwner = observer(
  ({ store }: { store: IntegrationHubspotSettingsTicketOwnerStore }) => {
    const { active, assignTo, options, toggleActive, setAssignTo } = store

    return (
      <div className={styles.wrap}>
        <TitledRow
          title={'Add ticket owner'}
          label={'Automatically set the owner of Help Desk tickets created from SMS conversations.'}
          verticalAlign={'start'}
          tooltip={'If no owner can be matched, the ticket is left unassigned.'}
          tooltipProps={{ maxWidth: 368 }}
          className={styles.ticketOwnerRow}
        >
          <Switch size='middle' value={active} onChange={toggleActive} />
        </TitledRow>
        {active && (
          <TitledRow
            title={'Auto-assign to'}
            verticalAlign={'center'}
            className={styles.autoAssignRow}
          >
            <SelectField
              className={styles.select}
              withSearch={false}
              value={assignTo}
              setValue={setAssignTo}
              size={'medium'}
              items={options}
              dropdownProps={{
                propsDropdownList: {
                  className: styles.dropdown,
                },
              }}
            />
          </TitledRow>
        )}
      </div>
    )
  }
)
